module.exports = __webpack_public_path__ + "static/media/bg_01@2x.1de732ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_01@2x.png
// module id = 2221
// module chunks = 0